module.exports = __webpack_public_path__ + "img/img2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img2.jpg
// module id = 1295
// module chunks = 0